






import { Component, Prop, Mixins } from "vue-property-decorator";

import { WidgetMixin, LayoutMixin } from "./mixins";

@Component({
  components: {
    WidgetGroup: () => import("@/components/WidgetGroup.vue"),
  },
})
export default class WFlex extends Mixins(WidgetMixin, LayoutMixin) {
  @Prop({
    type: String,
    default: "row",
    validator: (value: string) => ["row", "column"].includes(value),
  })
  direction!: string;

  @Prop({
    type: String,
    default: "start",
    validator: (value: string) =>
      ["start", "end", "center", "between", "around"].includes(value),
  })
  justify!: string;

  @Prop({
    type: String,
    default: "start",
    validator: (value: string) =>
      ["start", "end", "center", "baseline", "stretch"].includes(value),
  })
  align!: string;

  @Prop({ type: Boolean, default: false })
  fill!: boolean;

  get computedClasses() {
    return [
      "d-flex",
      `flex-${this.direction}`,
      `justify-content-${this.justify}`,
      `align-items-${this.align}`,
      {
        "flex-fill": this.fill,
      },
    ];
  }
}
